export default __webpack_public_path__ + "static/media/rgs_mobile.1167f200.jpg";